import BaseApiClient from '../BaseApiClient';
import type { ContactDataPoints } from '@interfaces/ContactDataPoints.interface';

const CONTACT_DATA_API_VERSION = '2025-11-14';

export class ApiContactData extends BaseApiClient {
  async getCompanyDataPoints(
    contactTypeId?: number | null
  ): Promise<ContactDataPoints> {
    return this.fetchDataPoints('companies/data-points', contactTypeId);
  }

  async getIndividualDataPoints(
    contactTypeId?: number | null
  ): Promise<ContactDataPoints> {
    return this.fetchDataPoints('individuals/data-points', contactTypeId);
  }

  private async fetchDataPoints(
    path: string,
    contactTypeId?: number | null
  ): Promise<ContactDataPoints> {
    const response = await this.client.get(path, {
      params: contactTypeId != null ? { contact_type_id: contactTypeId } : undefined,
      headers: { Version: CONTACT_DATA_API_VERSION }
    });

    if (!response.data) {
      throw new Error('Invalid contact data points response');
    }

    return response.data as ContactDataPoints;
  }
}
